var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.597.636a1.032 1.032 0 0 0-.811.78l-.844 3.376H2.169C.09 4.792.09 4.792.09 6.87v2.5c0 .414.203.735.617.942l1.493.552a2.57 2.57 0 0 0 2.565 2.24A2.561 2.561 0 0 0 7.3 11.026h8.441a2.561 2.561 0 0 0 2.533 2.078c1.363 0 2.435-1.015 2.565-2.338l.552-.357c.312-.207.52-.625.52-1.039V6.675a.96.96 0 0 0-.715-.909l-3.766-.682-2.663-3.279c-.527-.779-1.42-1.169-2.24-1.169H8.597zm1.007 2.078h2.922c.394 0 .47.04.584.228.02.032.041.064.065.097l1.396 1.753H9.084l.52-2.078zm-4.838 6.85a.942.942 0 1 1-.001 1.885.942.942 0 0 1 .001-1.884zm13.507 0a.942.942 0 1 1-.002 1.885.942.942 0 0 1 .002-1.884z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.fe2212fc29791e12b5d13eef1a6b6d32.svg";
export { ForwardRef as ReactComponent };